import {
    createHooks
} from '@wordpress/hooks';

let HookStore = createHooks();

export default HookStore;
